module.exports = {
	"name": "keen-tracking",
	"version": "1.4.0",
	"description": "Data Collection SDK for Keen IO",
	"main": "lib/server.js",
	"browser": "lib/browser.js",
	"repository": {
		"type": "git",
		"url": "https://github.com/keen/keen-tracking.js.git"
	},
	"scripts": {
		"start": "gulp with-tests",
		"test": "gulp test:cli"
	},
	"bugs": "https://github.com/keen/keen-tracking.js/issues",
	"author": "Dustin Larimer <dustin@keen.io> (https://keen.io/)",
	"contributors": [
		"Dustin Larimer <dustin@keen.io> (https://github.com/dustinlarimer)",
		"Eric Anderson <eric@keen.io> (https://github.com/aroc)",
		"Joe Wegner <joe@keen.io> (http://www.wegnerdesign.com)",
		"Alex Kleissner <alex@keen.io> (https://github.com/hex337)"
	],
	"license": "MIT",
	"dependencies": {
		"component-emitter": "^1.2.0",
		"js-cookie": "2.1.0",
		"keen-core": "^0.1.3"
	},
	"devDependencies": {
		"browserify": "^9.0.8",
		"chai": "^2.3.0",
		"chai-spies": "^0.6.0",
		"del": "^1.1.1",
		"gulp": "^3.8.11",
		"gulp-awspublish": "0.0.23",
		"gulp-connect": "^2.2.0",
		"gulp-derequire": "^2.1.0",
		"gulp-mocha": "^2.0.1",
		"gulp-mocha-phantomjs": "^0.6.1",
		"gulp-remove-empty-lines": "0.0.2",
		"gulp-rename": "^1.2.2",
		"gulp-replace": "^0.5.3",
		"gulp-sourcemaps": "^1.5.2",
		"gulp-strip-comments": "^1.0.1",
		"gulp-uglify": "^1.5.2",
		"gulp-util": "^3.0.4",
		"gulp-yuicompressor": "0.0.3",
		"karma": "^1.7.1",
		"karma-chrome-launcher": "^0.1.12",
		"karma-firefox-launcher": "^0.1.6",
		"karma-mocha": "^0.2.0",
		"karma-nyan-reporter": "0.0.60",
		"karma-requirejs": "^0.2.2",
		"karma-safari-launcher": "^0.1.1",
		"karma-sauce-launcher": "^0.2.11",
		"mocha": "^2.2.5",
		"moment": "^2.10.3",
		"phantomjs": "^1.9.7-15",
		"proclaim": "^3.3.0",
		"requirejs": "^2.3.5",
		"vinyl-buffer": "^1.0.0",
		"vinyl-source-stream": "^1.1.0"
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/keen-tracking/package.json
// module id = 1805
// module chunks = 0